/* hs-eslint ignored failing-rules */
/* eslint-disable no-bitwise */

'use es6';

import { isBoolean } from 'underscore';
import SeamlessImmutable from 'seamless-immutable';
import MenuNodeTypes from 'simple-menus-core/enums/MenuNodeTypes';
import StatesStatusGroups from 'ContentUtils/constants/StateStatusGroups';
import { byName } from 'ContentUtils/constants/TemplateTypes';
export default class MenuNode {
  constructor(props) {
    this.isPublished = MenuNode.getIsPublished(props);
    this.pageLinkId = props.pageLinkId || null;
    this.contentGroupId = props.contentGroupId || null;
    this.pageLinkName = props.pageLinkName || null;
    this.isDeleted = MenuNode.getIsDeleted(props) || null;
    this.categoryId = props.categoryId || null;
    this.subCategory = props.subCategory || null;
    this.contentType = props.contentType || null;
    this.state = props.state || null;
    this.linkLabel = props.linkLabel || '';
    this.linkUrl = props.linkUrl || null;
    this.linkParams = props.linkParams || null;
    this.linkTarget = props.linkTarget || null;
    this.type = MenuNode.getType(props);
    return SeamlessImmutable(this, {
      prototype: Object.getPrototypeOf(this)
    });
  }
  static getIsPublished(props) {
    if (isBoolean(props.isPublished)) {
      return props.isPublished;
    }
    if (isBoolean(props.is_published)) {
      return props.is_published;
    }
    if (isBoolean(props.published)) {
      return props.published;
    }

    /* Blog */
    if (props.categoryId === byName.blog.categoryId && !props.state) {
      return true;
    }
    return !!~StatesStatusGroups.PUBLISHED.indexOf(props.state);
  }
  static getIsDeleted(props) {
    if (props.deletedAt) {
      return true;
    }
    if (props.isDeleted || props.is_deleted) {
      return true;
    }
    return false;
  }
  static getType(props) {
    if (props.type) return props.type;
    if (props.pageLinkId || props.contentGroupId) {
      return props.linkParams ? MenuNodeTypes.PAGE_LINK_WITH_PARAMS : MenuNodeTypes.PAGE_LINK;
    }
    if (props.linkUrl) {
      return MenuNodeTypes.URL_LINK;
    }
    return MenuNodeTypes.NO_LINK;
  }
}